/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Flex, SectionGrid } from "frontend/src/components/Layout"
import { Logo } from "frontend/src/components/Logo"
import { LinkColumn, LogoColumn } from "./Column"
import { Line } from "./Line"

function Footer({ linkLists = [], logoLists = [], corporateLogo, motto }) {
  return (
    <SectionGrid sx={{ bg: "black", pt: 12, pb: [64, 64, 96], width: "100vw" }}>
      <SectionGrid.wide>
        <Flex.column align="stretch" sx={{ mx: [6, 8, 8, 0] }}>
          <Flex direction={["column", "column", "row"]} wrap>
            <Flex
              wrap
              direction={["column", "column", "row"]}
              sx={{ width: ["100%", "100%", "40%"] }}
            >
              {linkLists.map((column, i) => (
                <LinkColumn column={column} key={i} />
              ))}
            </Flex>
            <Flex
              wrap
              direction={["column", "column", "row"]}
              sx={{ width: ["100%", "100%", "60%"] }}
            >
              {logoLists.map((column, i) => (
                <LogoColumn column={column} key={i} />
              ))}
            </Flex>
          </Flex>
          <Line sx={{ display: ["none", "none", "block"], width: "100%" }} />
          {corporateLogo && (
            <Logo
              height={[39, 39, 57]}
              sx={{ mt: [0, 0, 10], mb: [0, 0, 3] }}
              name={corporateLogo}
              forceColor="white"
            />
          )}
          <div
            sx={{
              variant: "text.h4",
              color: "white",
              textAlign: "center",
              mx: 2,
            }}
          >
            {motto}
          </div>
        </Flex.column>
      </SectionGrid.wide>
    </SectionGrid>
  )
}

export { Footer }
